import type * as z from 'zod';

import { accountsReceivablesQuerySchema } from './accounts-receivables-query-schema';

export const accountsReceivablesFormSchema = accountsReceivablesQuerySchema.omit({
  invoice_id: true,
});

export type AccountsReceivablesFormSchema = z.infer<typeof accountsReceivablesFormSchema>;
